const RECHARGE_WIDGET_SELECTOR = 'recharge-subscription-widget';
const OVERRIDE_ATTRIBUTE = 'data-karam-recharge-overrides';

function applyRechargeWidgetOverrides(widget) {
  const shadowRoot = widget.shadowRoot;

  if (!shadowRoot || shadowRoot.querySelector(`[${OVERRIDE_ATTRIBUTE}]`)) {
    return;
  }

  const style = document.createElement('style');
  style.setAttribute(OVERRIDE_ATTRIBUTE, '');
  style.textContent = `
    [part~="rc-purchase-option__onetime"][rc-not-selected]
      [part~="rc-purchase-option__selector_onetime"] {
      font-weight: 400;
    }
  `;

  shadowRoot.append(style);
}

function applyRechargeWidgetOverridesToPage() {
  document.querySelectorAll(RECHARGE_WIDGET_SELECTOR).forEach(applyRechargeWidgetOverrides);
}

applyRechargeWidgetOverridesToPage();

if ('customElements' in window) {
  customElements
    .whenDefined(RECHARGE_WIDGET_SELECTOR)
    .then(applyRechargeWidgetOverridesToPage);
}

const productInfo = document.querySelector('.product-info');

if (productInfo) {
  const observer = new MutationObserver(applyRechargeWidgetOverridesToPage);
  observer.observe(productInfo, { childList: true, subtree: true });
}
